import React from 'react';
import Consignment from 'data/Consignment';
import OrderPreviewItem from 'components/Consignments/OrderPreviewItem';
import { CONSIGNMENT_TYPES } from 'constants/order';
import { SHIPPING } from 'constants/deliveryModes';
import { getCountryName } from 'utils/country';
import { capitalize } from 'utils/formatters';
import { stringifyPickupContact } from 'utils/consignment';

interface Props {
  consignments: Consignment[];
  totalSurcharges: number;
  currencyIso: string;
};

const OrderConsignmentList = ({ consignments }: Props) => {
  return (
    <div style={{ padding: '17px' }}>
      {
        consignments.map(consignment => {
          const isShipping = consignment.consignmentEntries![0].deliveryMode === SHIPPING;
          const shippingOptions = isShipping ? [
            consignment.deliveryAddress
              ? capitalize(`${consignment.deliveryAddress.addressLine1 ? consignment.deliveryAddress.addressLine1 + ',' : ''} 
                                      ${consignment.deliveryAddress.addressLine2 ? consignment.deliveryAddress.addressLine2 + ',' : ''} 
                                      ${consignment.deliveryAddress.town ? consignment.deliveryAddress.town + ',' : ''} 
                                      ${consignment.deliveryAddress.state ? consignment.deliveryAddress.state + ',' : ''} 
                                      ${consignment.deliveryAddress.postalCode || ''}`) +
              `${consignment.deliveryAddress.countryIsoCode && ', ' + getCountryName(consignment.deliveryAddress.countryIsoCode)}`
              : '',
            consignment.warehouse?.name || ''
          ] : [consignment.pointOfServiceLocation, consignment.warehouse?.name || '', stringifyPickupContact(consignment.pickupContact)];

          return (
            <OrderPreviewItem
              consignmentEntries={consignment.consignmentEntries!}
              state={consignment.state}
              orderTotalCost={consignment.totalPriceWithTax}
              isRental={consignment.consignmentType === CONSIGNMENT_TYPES.RENT}
              consignmentId={consignment.consignmentId}
              deliveryDate={consignment.availableDate}
              shippingOptions={shippingOptions}
              canNavigateToOrderDetails
              vendorName={consignment.vendor.name}
              countryId={consignment.countryId}
              consignmentSubtotal={consignment.totalPrice}
              consignmentTotalTax={consignment.totalTax}
              consignmentTotalSurcharges={consignment.totalSurcharges}
              deliveryCost={consignment.totalDeliveryCost}
            />
          )
        })
      }
    </div>
  );
};

export default OrderConsignmentList;
